import { IconButton, MenuItem, TextField } from "@mui/material";
import { PropValueLine } from "../../common/PropValueLine";
import { WorldRenderer } from "../../WorldRenderer";
import { C4Visual } from "../../../visuals/C4Visual";
import { Assignment } from "@mui/icons-material";
import { FlexContainer } from "../../../components/FlexContainer";
import { cloneVec3 } from "../../../visuals/visual-utils";
import { useState, useEffect } from "react";
import { FloorVisual } from "../../../visuals/FloorVisual";

export function C4Props({ wr, c4, onUpdate }: {
  wr: WorldRenderer,
  c4: C4Visual,
  onUpdate: (light: Partial<C4Visual>) => void
}) {
  const [floors, setFloors] = useState<FloorVisual[]>([]);
  useEffect(() => {
    const fs = Array.from(wr.dataService.visuals.values()).filter(v => v instanceof FloorVisual) as FloorVisual[];
    setFloors(fs);
  }, [wr]);

  return (
    <>
      <PropValueLine label='Floor' value={
        <FlexContainer>
          <TextField
            select
            value={c4.floorId || ''}
            variant="standard"
            size="small"
            onChange={(e) => {
              onUpdate({ floorId: e.target.value });
            }}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {floors.map((r) => (
              <MenuItem key={r._id} value={r._id}>
                {r.id}
              </MenuItem>
            ))}
          </TextField>
          <IconButton
            size='small'
            onClick={() => {
              if (c4.floorId) {
                const floor = wr.dataService.visuals.get(c4.floorId);
                if (floor) {
                  onUpdate({ position: cloneVec3(floor.position) });
                }
              }
            }}
          >
            <Assignment />
          </IconButton>
        </FlexContainer>
      } />
    </>
  );
} 